<template>
  <v-form @submit.prevent="$emit('save', user)">
    <v-card>
      <v-card-title>
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="user.person.first_name"
              :error-messages="errors['person.first_name']"
              :label="formMixin_getRequiredFieldLabel($t('first_name'))"
              name="first_name"
              autofocus
              @input="formMixin_clearErrors('person.first_name')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              v-model="user.person.last_name"
              :error-messages="errors['person.last_name']"
              :label="formMixin_getRequiredFieldLabel($t('last_name'))"
              name="last_name"
              @input="formMixin_clearErrors('person.last_name')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              v-model="user.email"
              :error-messages="errors['email']"
              :label="formMixin_getRequiredFieldLabel($t('email'))"
              name="email"
              @input="formMixin_clearErrors('email')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              v-model="user.person.phone"
              :error-messages="errors['person.phone']"
              :label="$t('phone')"
              name="phone"
              @input="formMixin_clearErrors('phone')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              v-model="user.person.address"
              :error-messages="errors['person.address']"
              :label="$t('address')"
              name="address"
              @input="formMixin_clearErrors('person.address')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
              v-model="user.role"
              :items="roles"
              :disabled="$isCurrentUser(user.id)"
              :error-messages="errors['role']"
              :label="$t('role')"
              @change="formMixin_clearErrors('role')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
              v-model="user.status"
              :items="statuses"
              :disabled="$isCurrentUser(user.id)"
              :error-messages="errors['status']"
              :label="$t('status')"
              @change="formMixin_clearErrors('status')"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <span v-if="!user.id" class="text-subtitle-2 ml-3"> * {{ $t('must_be_filled') }} </span>

        <v-spacer />

        <v-btn text color="primary" @click="$emit('cancel')">
          {{ $t('cancel') }}
        </v-btn>

        <v-btn :disabled="disabled" :loading="disabled" color="primary" text type="submit">
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import formMixin from '../mixins/form-mixin';

export default {
  name: 'UserForm',

  props: {
    user: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [formMixin],

  computed: {
    ...mapGetters('users', ['roles', 'statuses']),

    formTitle() {
      return this.$t(this.user.id ? 'edit_user' : 'new_user');
    },
  },
};
</script>
